var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),(_vm.fCliente == _vm.fAsprofili)?_c('v-app',[_c('br'),_c('CadastroAsprofili'),_c('br')],1):_c('v-app',[_c('br'),_c('CadastroAne'),_c('br')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }